import React, { useState, useEffect } from 'react';
import './style.scss';
import { Input } from 'reactstrap'

function FeedsListMobile(props) {
    const [searchValue, setSearchValue] = useState('');
    const [visibleFeeds, changeVisibleFeeds] = useState([]);

    useEffect(() => {
        changeVisibleFeeds(props.feeds);
        setSearchValue('');
    }, [props.feeds])

    const handleSearchChange = (value) => {
        if (value === '') {
            setSearchValue('');
            changeVisibleFeeds([...props.feeds]);
        } else {
            const visibleList = props.feeds.filter(item => item.attachedName.toLowerCase().includes(value.toLowerCase()));
            changeVisibleFeeds(visibleList);
            setSearchValue(value);
        }
    }

    return (
        <div className="feeds_list_mobile-container" style={{ display: props.isFirstTabSelected ? 'flex' : 'none' }}>
            <div>
                <div className="reader-block_header-container">
                    <h2 className="reader-block_header">
                        Entities
                        {/*<span style={{ fontSize: '1.25rem' }}>
                        {` (${props.feedsLoading ? 'Loading' : (visibleFeeds && visibleFeeds.length) ? visibleFeeds.length + ' Results' : 'No Results'})`}
                        </span>*/}
                    </h2>
                    {!props.feedsLoading && visibleFeeds && visibleFeeds.length > 0 &&
                        <div className="counter-circle" style={{ backgroundColor: 'white', color: '#314784', fontSize: '20px' }}>
                            {visibleFeeds.length}
                        </div>
                    }
                </div> 
                {props.feeds.length > 0 &&
                    <div className="reader-input-container">
                        <Input
                            style={{ backgroundColor: 'rgb(228, 229, 230)' }}
                            onChange={(e) => handleSearchChange(e.target.value)}
                            value={searchValue}
                            placeholder="Search by Entity name"
                            type="text"
                            className="searchInput reader-input"
                        />
                        {!searchValue ? (
                            <i style={{ cursor: 'default' }} className="fa fa-search search-container_icon" />
                        ) : (
                            <i onClick={() => handleSearchChange('')} className="fa fa-times-circle search-container_icon" />
                        )}
                    </div>
                }
            </div>
            {props.feedsLoading ? (
                <div style={{ height: 'calc(100vh - 55px - 150px)', borderTop: '1px solid rgb(228, 229, 230)', padding: '10px 0 0 15px' }}>
                    <i className="fa fa-spinner fa-spin" />
                </div>
            ) : (
                <div style={{ overflowY: 'auto', height: 'calc(100vh - 55px - 150px)', borderTop: '1px solid rgb(228, 229, 230)' }}>
                    {(visibleFeeds && visibleFeeds.length > 0) 
                        ? visibleFeeds.map(feed => 
                            <div 
                                style={{ 
                                    backgroundColor: feed.id === props.selectedFeed.id ? 'rgba(106, 0, 255, 0.8)' : 'rgba(49, 71, 132, 0.9)',
                                    fontSize: '0.875rem',
                                }} 
                                onClick={() => props.setSelectedFeed(feed)}
                                key={feed.id}
                                className="feeds_list-list_item-container"
                            >
                                <div className="feeds_list-list_item-name">{feed.attachedName}</div>
                                <div className="feeds_list-list_item-counter">{feed.countNews}</div>
                            </div>    
                        ) : (
                            <div style={{ padding: '10px 15px', fontSize: '0.875rem' }}>
                                No Newsfeeds found
                            </div>
                        )
                    }
                </div>
            )}
        </div>
    );
}

export default FeedsListMobile;